import React, {Component} from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as wActs from '../actions/website-actions';

class CountrySelect extends Component {


  constructor(props) {
    super(props);
    this.Clicked = false;
    this.state = {ShowingMenu: false}
  }

  toggleCC() {
    if(this.state.ShowingMenu) {this.setState({ShowingMenu: false})} else {this.setState({ShowingMenu: true})}
  }



  handleDropClick(e) {
    e.preventDefault();
    if(!this.Clicked) {
      this.toggleCC();
    } else {
      this.Clicked = false;
    }
  }

  handleLanguageClick(e,dta) {
    let smtLan = this.props.WebPage.Settings.SmartDefaultLanguage;
    e.preventDefault();
    this.Clicked = true;
    this.toggleCC();
    wActs.getCultPathByLang(this.props.WebPage,dta.Code);
    localStorage.setItem(wActs.lsKey,dta.Default && smtLan ? "/" : dta.Path);
    wActs.setCookie(wActs.lsKey, dta.Default && smtLan ? "/" : dta.Path, { path: "/", maxAge: 31557600, domain: "." + wActs.getSubdomain(window.location.hostname) });
    let loc = dta.Default && smtLan ? wActs.getLocationWithSearch("/") : wActs.getLocationWithSearch(wActs.stripCulturePath(dta.Path));
    if(this.props.WebPage.PageType === "blog") {
      loc = "/blog";
    }
    if (loc.endsWith("/") && loc !== "/") {
      loc = loc.substr(0, loc.length - 1);
    }
    document.location = loc;
  }

  defaultLanguage() {
    return this.props.WebPage.Settings.DefaultLanguageCode === "undefined" ? "DUTCH" : this.props.WebPage.Settings.DefaultLanguageCode;
  }




  renderSelected() {

    //console.log("Rendering ", this.props.WebPage.Settings.Languages)

    let tStyle = {minWidth: "140px", zIndex: "99", top: "15px", left: "-20px", display: this.state.ShowingMenu ? 'block' : 'none', overflowY: 'hidden', border: 'solid 2px rgb(23, 51, 128)', boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.65)'};


    return (
      <div className="country-select inside">
        <div className="flag-dropdown" onClick={(e) => {this.handleDropClick(e)}}>
          {
            this.props.WebPage.Settings.Languages.map((v,i)=>{
              //let defLang = this.defaultLanguage();
              let selLang = wActs.getCultByPath(this.props.WebPage,this.props.WebPage.Settings.SelectedLocal).Path;
              if(selLang === "en") { selLang="gb"; }
              //console.log(v);
              if(v.Selected) {
                return (<div key={"cc-selected-" + i} className="selected-flag" title={v.Name}>
                  <div className={"flag " + selLang}></div>
                  <div className="arrow"></div>
                </div>);
              } else {
                return null;
              }
            })
          }

          <ul id={"cc-drop-down"} className={"country-list"} style={tStyle}>
            {
              this.props.WebPage.Settings.Languages.map((v,i) => {
                let cc = v.Path;
                let borderBottom = "none";
                if(cc === "en") {cc="gb"}
                if(i !== this.props.WebPage.Settings.Languages.length-1) {borderBottom = "solid 2px #454545"}
                return v.Path !== "xx" ? <li onClick={(evt) => this.handleLanguageClick(evt,v)} style={{display: "block", width: "100%",margin: "auto", backgroundColor: '#15275b', borderBottom: borderBottom, padding: "0px 10px"}} key={"cc-select-option-" + i} className="country" data-country-code={cc}><div className={`flag ${cc}`}></div><span className="country-name">{v.Name}</span></li> : null;
              })
            }
          </ul>
        </div>
      </div>
    );
  }


  render() {



    return this.renderSelected();
  }

}

const mapStateToProps = (state) => {
  return  {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(CountrySelect);
